export const customFieldsConstants = {
   //NOTE: CallLog custom fields
   assigneeId: 'user_id',
   callDateTime: 'call_datetime',
   taskCallStatus: 'task_call_status',
   callLogId: 'call_log_id',
   callDuration: 'call_duration',
   stageId: 'pipeline_item_stage_id',

   //NOTE: Task custom fields
   taskTemplateId: 'task_template_id',
   taskAssigneeId: 'assignee_id',
   callStatus: 'call_status',
   completedAt: 'completed_at',
   callLogIds: 'call_log_ids',

   //NOTE: Activity custom fields
   activityTemplateId: 'activity_template_id',
   activityDateTime: 'activity_datetime',
   activityId: 'activity_id',

   //NOTE: Task and CallLog custom fields
   taskId: 'task_id',

   //NOTE: Task, Activity & CallLog custom fields
   pipelineItemId: 'pipeline_item_id',

   //NOTE: Stage History custom fields
   stageHistoryPipelineItemId: 'stage_history_pipeline_item_id',
   fromStageId: 'from_stage_id',
   toStageId: 'to_stage_id',
   stageChangedAt: 'stage_changed_at'
}
